export function getFormBreadCrumbs() {
  return [
    {
      label: 'Управление формами',
      to: '/forms'
    }
  ];
}
